/* import __COLOCATED_TEMPLATE__ from './feedback-dialog.hbs.js'; */
var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { set, action, computed } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

/**
 * @param {Action} [onDismiss] - Action to be fired when dialog is dismissed
 * @param {Action} [logFeedback] - Action to be fired when user clicks "share"
 * @param {Action} [feedbackReasons] - Feedback items to be displayed as options for user to choose
 */
let FeedbackDialog = (_dec = computed('feedbackReasons.[]'), _class = class FeedbackDialog extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "responseText", _descriptor, this);
  }
  didInsert() {
    const {
      feedbackReasons
    } = this.args;
    set(this, 'feedbackReasons', feedbackReasons.map(reason => {
      return {
        ...reason,
        selected: false
      };
    }));
  }
  get selectedReasonIds() {
    return this.feedbackReasons.filter(reason => reason.selected).map(reason => reason.id);
  }
  confirmShareFeedback() {
    this.args.logFeedback(this.selectedReasonIds, this.responseText);
    this.args.onDismiss();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "responseText", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "didInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "didInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedReasonIds", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "selectedReasonIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirmShareFeedback", [action], Object.getOwnPropertyDescriptor(_class.prototype, "confirmShareFeedback"), _class.prototype), _class);
export { FeedbackDialog as default };